import { FC } from 'react';

import Table from 'modules/_shared/Table';

import PartnersTableViewHeader from './PartnersTableViewHeader';
import PartnersTableViewBody from './PartersTableViewBody';
import { useNotifyPartnersDividendsModal } from '../context/NotifyPartnersDividendsModalContext';

const PartnersTableView: FC = () => {
  const { data } = useNotifyPartnersDividendsModal();

  const tableContent = (
    <>
      <PartnersTableViewHeader />
      {data.expandView && <PartnersTableViewBody />}
    </>
  );

  return <Table content={tableContent} />;
};

export default PartnersTableView;
